import React from "react";
import { useRouter } from "next/router";

const usePersistedLanguage = () => {
  const router = useRouter();

  React.useEffect(() => {
    const storedLocale = localStorage.getItem("BOTATENDE_LOCALE");

    if (storedLocale && router.locale !== storedLocale) {
      const currentPath = router.asPath;
      router.push(`/${storedLocale}${currentPath}`);
    }
  }, [router]);
};

export default usePersistedLanguage;